import { makeStyles } from "@material-ui/core";
import loader from "../inc/loader.gif";
const useStyles = makeStyles((theme) => ({
	root: {
		height: "100vh",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	loadingImage: {
		maxWidth: "75px",
	},
}));
function Loading() {
	const classes = useStyles();
	return (
		<div className={classes.root}>
			<img className={classes.loadingImage} src={loader} alt="loader" />
		</div>
	);
}

export default Loading;
